import { useEditor, useNode } from "@craftjs/core";
import ContentEditable from "react-contenteditable";
import Toolbar from "./Toolbar";

interface TextProps {
    text: string;
}

const DownloadsTitle = ({ text }: TextProps) => {
    const {
        connectors: { connect },
        actions: { setProp },
    } = useNode();
    const { enabled } = useEditor((state) => ({ enabled: state.options.enabled }));

    return (
        <div ref={(ref) => connect(ref!)} className="content-center break-words slogan">
            <ContentEditable
                html={text || "Title goes here"}
                disabled={!enabled}
                onChange={(e) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setProp((prop: any) => (prop.text = e.target.value), 500);
                }}
                tagName="h1"
                className="break-words"
            />
        </div>
    );
};

DownloadsTitle.craft = {
    displayName: "Title",
    props: {
        text: "Text",
    },
    related: {
        toolbar: Toolbar,
    },
};

export default DownloadsTitle;
